<div class="flex justify-between items-center mb-4">
  <div class="text-xl text-gray-700 font-bold">
    OS do TG {{ item.codigoTg }} — {{ item.nomeEvento }}
  </div>
  <button mat-button (click)="close()">Fechar</button>
</div>

<div class="mb-4 flex flex-wrap gap-6">
  <div><b>OS com fornecedor: </b>{{ item.osComFornecedor ?? 0 }}</div>
  <div><b>Venda sem taxa: </b>{{ formatCurrency(item.totalValorVendaSemTaxa) }}</div>
  <div><b>Total compra: </b>{{ formatCurrency(item.totalValorCompra) }}</div>
  <div><b>Total comprado: </b>{{ formatCurrency(item.totalValorComprado) }}</div>
  <div><b>Savings: </b>{{ formatCurrency(item.totalSavings) }}</div>
</div>

<div class="mb-3">
  @if (!selectionMode) {
    <button mat-flat-button class="btn-tg" (click)="startSelection()">
      Selecionar OS(s)
    </button>
  } @else {
    <div class="flex gap-2">
      <button mat-flat-button class="btn-tg-white" (click)="cancelSelection()">
        Cancelar
      </button>
      <button mat-flat-button class="btn-tg" (click)="confirmSelection()">
        Confirmar ({{ selectedCosIds.length }})
      </button>
    </div>
  }
</div>

@if (!loading) {
  <table-list-purchase-reservation-service-order
    [dataSource]="itemsList"
    [columns]="columns"
    [selectedIds]="selectedCosIds"
    (editItem)="editItem($event)"
    (copyLinkItem)="copyLinkItem($event)"
    (sendEmailItem)="sendEmailItem($event)"
    (sendToFleet)="sendToFleetItem($event)"
    (toggleSelectItem)="toggleSelectItem($event)"
    (toggleSelectAll)="toggleSelectAllItems($event)"
  />
} @else {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
